import React from 'react';
import { CheckCircle2, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
const items = [<>
    Logras generar contenido que por fin{' '}
    <strong className="text-emerald-400 font-bold" data-id="element-1">conecta y VENDE</strong>
  </>, <>
    Generas ingresos constantes que{' '}
    <strong className="text-emerald-400 font-bold" data-id="element-2">crecen mes a mes</strong>
  </>, <>
    Colaboras con cientos de marcas que{' '}
    <strong className="text-emerald-400 font-bold" data-id="element-3">
      te pagan y dan productos y servicios GRATIS
    </strong>
  </>];
export function AfterSection() {
  return <section className="px-6 py-8 flex flex-col items-center text-center max-w-7xl mx-auto pt-[0px] pb-[0px]" data-id="element-4">
      <div className="w-full max-w-5xl relative rounded-[2.5rem] p-[2px] bg-gradient-to-b from-emerald-500/50 via-emerald-900/30 to-transparent shadow-[0_20px_60px_-15px_rgba(16,185,129,0.25)]" data-id="element-5">
        <div className="bg-[#0a120e] rounded-[2.4rem] px-6 py-10 md:px-12 md:py-12 relative overflow-hidden flex flex-col items-center" data-id="element-6">
          {/* Ambient emerald neon glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-emerald-500/10 blur-[120px] rounded-full pointer-events-none" data-id="element-7" />

          <div className="inline-flex items-center gap-2 bg-emerald-500/10 border border-emerald-500/30 text-emerald-400 font-bold text-[12px] md:text-sm uppercase tracking-[0.2em] px-6 py-2.5 rounded-full mb-8 backdrop-blur-sm relative z-10" data-id="element-8">
            <Sparkles size={16} strokeWidth={2.5} data-id="element-9" />
            La transformación
          </div>

          <h2 className="font-black text-[32px] md:text-[54px] leading-[1.1] tracking-tight uppercase mb-14 text-white drop-shadow-[0_0_15px_rgba(16,185,129,0.5)] relative z-10" style={{
          fontFamily: "'Inter', sans-serif",
          fontWeight: 900
        }} data-id="element-10">
            Después de <span className="text-emerald-400" data-id="element-11">acceder</span>
          </h2>

          <ul className="w-full grid grid-cols-1 md:grid-cols-3 gap-6 text-left max-w-5xl mx-auto relative z-10" data-id="element-12">
            {items.map((item, i) => <motion.li key={i} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.1
          }} className="flex items-start gap-4 bg-white/[0.02] border border-emerald-500/20 rounded-2xl p-6 md:p-8 backdrop-blur-sm hover:bg-white/[0.04] hover:border-emerald-500/40 transition-all" data-id="element-13">
                <div className="w-10 h-10 shrink-0 rounded-full bg-emerald-500/10 flex items-center justify-center border border-emerald-500/30 mt-0.5" data-id="element-14">
                  <CheckCircle2 size={20} strokeWidth={2.5} className="text-emerald-400" data-id="element-15" />
                </div>
                <span className="font-medium text-white/90 text-[16px] md:text-[18px] leading-relaxed" data-id="element-16">
                  {item}
                </span>
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}